import { render, staticRenderFns } from "./rightSiteMenue.vue?vue&type=template&id=2dfb1c70"
import script from "./rightSiteMenue.vue?vue&type=script&lang=js"
export * from "./rightSiteMenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports